// The hint an interval chip opens in the Map mode: where the cell's key sits
// on the neck relative to home, and the soloing key, or, for an approach cell
// (no landing), the landing it leans into. Pure, so the view stays a
// components-only module for fast refresh and the words can be tested.

import { FRETBOARD_HINTS, type TuneMap, type TuneMapCell } from '@/music/tuneMap';

export function cellHint(map: TuneMap, cell: TuneMapCell): string {
  const where = `${cell.interval}: ${FRETBOARD_HINTS[cell.interval]}.`;
  if (!cell.approach) return `${where} Solo in ${cell.key.label}.`;
  const next = cell.leansInto == null ? null : map.cells[cell.leansInto];
  return next ? `${where} Lean into ${next.key.label}.` : where;
}
